import { render, staticRenderFns } from "./AuthorJinNangStatistic.vue?vue&type=template&id=7a36565f&scoped=true&"
import script from "./AuthorJinNangStatistic.vue?vue&type=script&lang=js&"
export * from "./AuthorJinNangStatistic.vue?vue&type=script&lang=js&"
import style0 from "./AuthorJinNangStatistic.vue?vue&type=style&index=0&id=7a36565f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a36565f",
  null
  
)

export default component.exports